/**
 * Conversation scope (Inicio, spec S12) — the dashboard's read side of the
 * session field `/verifyToken` sends as `conversationScope: { restricted }`.
 *
 * The backend decides who is restricted (today: admin/superadmin of a company
 * with Inicio whose role lacks «Ver todas las conversaciones»); the dashboard
 * only follows the flag. A restricted user sees the chat like a session with
 * role agent/vendedor: only the conversations assigned to them, no «Todo»,
 * and their conversation events on `agent_<userId>`.
 *
 * Fail open towards today's behavior: an absent or malformed value (a backend
 * without the field) means not restricted. Only a literal `true` counts.
 */
export const isConversationScopeRestricted = (userData) => {
  const scope = userData && userData.conversationScope;
  if (!scope || typeof scope !== 'object') return false;
  return scope.restricted === true;
};

/**
 * «Todo» (every conversation of the company): permission readUsers, as
 * always, unless the user is conversation-restricted.
 */
export const canSeeAllConversations = (userData) => {
  const permissions = userData && userData.permissions;
  if (!permissions || !permissions.readUsers) return false;
  return !isConversationScopeRestricted(userData);
};
